<template>
  <div class="thermal-print">
    <!-- Logo -->
    <!-- <div class="image-logo-placement">
      <img v-if="
        result.branch &&
        (result.branch.photo_url.includes('png') ||
          result.branch.photo_url.includes('jpg'))
      " :src="result.branch.photo_url" alt="logo" class="image-logo-android" />
      
    </div> -->
    <table style="width: 100%" v-if="userData && userData.photo_url">
      <tr>
        <td style="text-align: center;">
          <img :src="userData.photo_url" alt="logo" class="image-logo-android" />
        </td>
      </tr>
    </table>
    <div class="piutang-title" style="font-size: 18px !important; font-weight: 900 !important; margin-top: 1.5rem !important;">
      Pembayaran Piutang
    </div>
    <!-- Header -->
    <div class="header" style="margin-left: 0px !important; margin-right: 0px !important;">
      <div class="branch-name text-black" style="font-size: 14px !important; margin-bottom: 5px !important;">
        {{ userData.name  || "-" }}
      </div>
      <div class="branch-address text-black" style="font-size: 14px !important; margin-bottom: 5px !important;">
        {{ userData.address }}<span v-if="userData.postal_code && userData.postal_code !== 'null'">, {{ userData.postal_code }}</span>
      </div>
      <div class="branch-phone text-black" style="font-size: 14px !important; margin-bottom: 5px !important;">
        Tlp: {{ userData.phone }}
      </div>
    </div>

    <!-- Invoice Details -->
    <div class="invoice-details" style="margin-left: 0px !important; margin-right: 0px !important;">
      <div style="font-size: 14px !important; margin-bottom: 5px !important;">Pelanggan: {{ result.customer.name || '-' }}</div>
      <div style="font-size: 14px !important; margin-bottom: 5px !important;">Alamat Pelanggan: {{ result.customer.address || "-" }}</div>
      <div style="font-size: 14px !important; margin-bottom: 5px !important;">Tanggal Pembayaran: {{ result.payment_date || "-" }}</div>
      <div style="font-size: 14px !important; margin-bottom: 5px !important;">No. Invoice: {{ result.invoice_number || "-" }}</div>
    </div>

    <div style="border-top: 1px solid #000; margin: 16px 0"></div>

    <!-- Payment Table -->
    <div class="product-list">
      <div class="product-item">
        <div class="product-details" style="margin-bottom: 0.5rem !important;">
          <div class="product-details-type" style="width: 25% !important;">
            <span>Jumlah</span>
          </div>
          <div class="product-details-price" style="width: 25% !important;">
            <span>Sisa</span>
          </div>
          <div class="product-details-price" style="margin-right: 25px !important;">
            <span>Keterangan</span>
          </div>
        </div>
        <div class="product-details">
          <div class="product-details-type" style="width: 25% !important;">
            <span>{{ result.amount | formatAmountAndroid }}</span>
          </div>
          <div class="product-details-price" style="width: 25% !important;">
            <span>{{ Number(result.unpaid) | formatAmountAndroid }}</span>
          </div>
          <div class="product-details-price" style="margin-right: 25px !important;">
            <span>{{ Number(result.unpaid) > 0 ? "Belum Lunas" : "Lunas" }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="border-top: 1px solid #000; margin: 16px 0"></div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "PaymentThermalPrintTemplate",
  props: {
    result: Object,
  },
  data() {
    return {
      fields: [],
      fieldsPrint: [],
      items: [],
      supplier: {},
      imageLogo: null,
      userData: JSON.parse(localStorage.getItem('userData')).branch,
      payment_date: '',
      invoice_number: '',
      moment,
    }
  },
  result: {
    handler(value) {
      if (value) {
        const isValid = this.hasNoImageExtension(value?.branch?.photo_url)
        this.imageLogo = isValid ? value.branch?.photo_url : ``
        this.supplier = value.customer
        this.payment_date = value.payment_date
        this.invoice_number = value.invoice_number

        this.fields = ['invoice_number', 'jumlah', 'sisa', 'keterangan']
        this.fieldsPrint = [
          {
            key: 'jumlah',
            label: 'Jumlah',
          },
          {
            key: 'sisa',
            label: 'Sisa',
          },
          {
            key: 'keterangan',
            label: 'Keterangan',
          }
        ];

        this.items = [{
          invoice_number: value.invoice_number,
          jumlah: value.amount,
          sisa: value.unpaid,
          keterangan: value.unpaid,
        }]
      }
    },
    deep: true
  },
  mounted() {
    this.getData()
    const isValid = this.hasNoImageExtension(this.userData?.photo_url)
    this.imageLogo = isValid ? this.userData?.photo_url : ''
  },
  computed: {
    formattedCreatedAt() {
      const date = this.result?.created_at || this.result?.date;
      if (!date) return '';
      return this.moment(date).format('DD/MMM/YYYY HH:mm:ss');
    }
  },
  methods: {
    getData() {
      this.supplier = this.result.customer
      this.fields = ['invoice_number', 'jumlah', 'sisa', 'keterangan'];
      this.fieldsPrint = [
        {
          key: 'jumlah',
          label: 'Jumlah',
        },
        {
          key: 'sisa',
          label: 'Sisa',
        },
        {
          key: 'keterangan',
          label: 'Keterangan',
        }
      ];
      this.payment_date = this.result.payment_date
      this.invoice_number = this.result.invoice_number
      this.items = [{
        invoice_number: this.result.invoice_number,
        jumlah: this.result.amount,
        sisa: this.result.unpaid,
        keterangan: this.result.unpaid,
      }]
    },
    hasNoImageExtension(url) {
      const validExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      return validExtensions.test(url);
    },
    formatAmountAndroid(value) {
      // Implement your formatting logic here
      return value;
    },
    sumSplitPayment(payments) {
      return payments.reduce(
        (total, payment) => total + parseFloat(payment.amount),
        0
      );
    },
  },
};
</script>

<!-- <style scoped>
  .thermal-print {
    font-family: 'Courier', monospace;
    font-size: 12px;
    line-height: 1.2;
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    padding: 10px 0;
  }

  .logo {
    display: block;
    margin: 0 auto 10px;
    max-width: 60px !important;
    height: auto;
  }
  
  .header, .invoice-details, .product-list, .summary, .notes {
    margin-bottom: 10px;
  }
  
  .branch-name {
    font-size: 42px !important;
    font-weight: bold;
  }
  
  .divider {
    border-top: 1px dashed #000;
    margin: 10px 0;
  }
  
  .product-item {
    margin-bottom: 5px;
  }
  
  .product-name {
    font-weight: bold;
  }
  
  .product-details {
    display: flex;
    justify-content: space-between;
  }
  
  .summary-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
  }
  
  .summary-header {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .total {
    font-weight: bold;
    font-size: 42px !important;
    margin-top: 5px;
  }
  
  .note-header {
    font-weight: bold;
    margin-bottom: 2px;
  }
  
  .note-item {
    font-style: italic;
  }
  
  .additional-info, .cancellation-info {
    margin-top: 10px;
    font-style: italic;
  }
  
  .cancellation-info {
    color: #ff0000;
  }
  </style> -->
